import BookingService from '../bookings/BookingService';

const GoalService = {
  async saveGoal(formData) {
    try {
      let url = '/api/performance/goal';
      let method = 'POST';
      const profileLogged = JSON.parse(localStorage.getItem('profile'));
      const { accountIdentifier } = profileLogged;
      if (formData.identifier !== undefined) {
        url = '/api/performance/goal/' + formData.identifier;
        method = 'PUT';
      }
      const updateData = {
        ...formData,
        accountIdentifier: accountIdentifier,
        profileIdentifier: profileLogged.identifier,
        type: formData.type.value,
        category: formData.category.value
      };
      console.log(updateData);

      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updateData)
      });
      if (response.ok) {
        const newGoal = await response.json();
        console.log('Goal has been updated:', newGoal);
      }
    } catch (error) {
      console.log('Error saving Goal', error);
    }
  },
  getCurrent(
    goal,
    totalBookings,
    totalBookingsThisMonth,
    totalBookingsThisyear
  ) {
    if (goal.category === 'attendance') {
      if (goal.type === 'lifetime') {
        return totalBookings;
      }
      if (goal.type === 'month') {
        return totalBookingsThisMonth;
      }
      if (goal.type === 'year') {
        return totalBookingsThisyear;
      }
      return 0;
    }
  },
  async retrieveGoalsByUser() {
    try {
      const profileLogged = JSON.parse(localStorage.getItem('profile'));
      const { identifier } = profileLogged;
      const { accountIdentifier } = profileLogged;
      const response = await fetch(
        '/api/performance/goal/account/' + accountIdentifier
      );
      const goals = await response.json();

      const bookings = await BookingService.retrieveAllBookingsByUser(
        identifier
      );
      const totalBookings = bookings.length;
      const totalBookingsThisYear = bookings.filter(booking => {
        const bookingDate = new Date(booking.date);
        const currentYear = new Date().getFullYear();
        return bookingDate.getFullYear() === currentYear;
      }).length;
      const totalBookingsThisMonth = bookings.filter(booking => {
        const bookingDate = new Date(booking.date);
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth();
        return (
          bookingDate.getFullYear() === currentYear &&
          bookingDate.getMonth() === currentMonth
        );
      }).length;
      const updatedGoals = goals.map(g => {
        const current = this.getCurrent(
          g,
          totalBookings,
          totalBookingsThisMonth,
          totalBookingsThisYear
        );
        const target = Number(g.targetValue);

        const percentage = target > 0 ? Math.round((current / target) * 100) : 0;

        return {
          ...g,
          current: current,
          percentage: percentage
        };
      });
      return updatedGoals;
    } catch (error) {
      console.error('Error fetching Goals', error);
      throw error;
    }
  },
  async retrieveAllGoalByAccount() {
    try {
      const { accountIdentifier } = JSON.parse(localStorage.getItem('profile'));
      console.log(accountIdentifier);
      const response = await fetch(
        '/api/performance/goal/account/' + accountIdentifier
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching Goal', error);
      throw error;
    }
  },
  async retrieveGoal(identifier) {
    try {
      const response = await fetch('/api/performance/goal/' + identifier);
      const data = await response.json();

      return data;
    } catch (error) {
      console.error('Error fetching Goal', error);
      throw error;
    }
  },
  async deleteGoal(identifier) {
    try {
      let url = '/api/performance/goal/' + identifier;
      let method = 'DELETE';
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        const newGoal = await response.json();
        console.log('Goal has been deleted:', newGoal);
      }
    } catch (error) {
      console.log('Error deleting Goal', error);
    }
  }
};
export default GoalService;
